import { MeterGroupDesignTokens } from '@primeuix/themes/types/metergroup';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/metergroup/index.ts
const mg = componentCommon.metergroup;

export const MetergroupTelekomDT: MeterGroupDesignTokens = {
  root: {
    borderRadius: t(mg.border.radius),
    gap: t(mg.gap),
  },
  meters: {
    background: t(mg.meters.background),
    size: t(mg.meters.size),
  },
  label: {
    gap: t(mg.label.gap),
  },
  labelMarker: {
    size: t(mg.label.marker.size),
  },
  labelIcon: {
    size: t(mg.label.icon.size),
  },
  labelList: {
    verticalGap: t(mg.label.list.vertical.gap),
    horizontalGap: t(mg.label.list.horizontal.gap),
  },
};
